import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer} from '@angular/forms';
import { Filter } from '../../../../models/filter.models';


@Component({
  selector: 'text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent implements OnInit {
  public textFormGroup :any ;
  constructor(
    public controlContainer: ControlContainer
  ) {
  }

  @Input() data: Filter

  ngOnInit(): void {
    this.textFormGroup = this.controlContainer.control
  }

}
